/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Vlt-icon-density-medium': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21.2 5.3H2.8c-.5 0-.8-.3-.8-.7s.3-.8.7-.8h18.6c.4 0 .8.3.8.7s-.4.8-.9.8c.1 0 .1 0 0 0zm0 9.8H2.8c-.4 0-.8-.3-.8-.7s.3-.8.7-.8h18.6c.4 0 .8.3.8.7s-.4.8-.9.8c.1 0 .1 0 0 0zm0-4.9H2.8c-.5 0-.8-.3-.8-.8 0-.4.3-.7.8-.7h18.5c.4 0 .7.3.7.7 0 .5-.3.8-.8.8zm0 9.8H2.8c-.5 0-.8-.4-.8-.8s.3-.8.8-.8h18.5c.4 0 .8.3.8.8-.1.4-.4.8-.9.8z"/>'
  }
})
